export default __webpack_public_path__ + "static/media/info_image_01.e44fcab8.png";